<template>
    <div>
        <div class="list" v-if="list.length">
            <div v-for="(item,index) in list" :key="index">
                <div class="user">
                    <div>
                        <img src="" alt="">
                        <div>
                            <div>{{item.receiveUserName}}-{{item.sendOutName}}</div>
                            <span>{{item.sendTime}}</span>
                        </div>
                    </div>
                    <span class="delete">删除</span>
                </div>
                <div class="aircat">
                    <div class="tit">{{item.offMessage.mailTitle}}</div>
                    <div class="msg">{{item.offMessage.mailContent}}</div>
                </div>
            </div>
        </div>
		<div v-else>暂时没有数据</div>

		<hxlPagin :queryParams="queryParams" @changePage="changePage"/>

    </div>
</template>

<script>
import {queryCurrentUserMessage} from '@/api/personalCenter'
import hxlPagin from "@/components/hxlPagin"; 
export default {
	components:{hxlPagin},
	data(){
		return{
			queryParams:{
				pageNum:1,
				pageSize:10,
				total: 100,
			},
			list:[]
		}
	},
	mounted(){
		this.getList()
	},
	methods:{
		changePage (e) { this.queryParams.pageNum = e; this.getList(); },
		getList(){
			queryCurrentUserMessage().then(res=>{
				this.list = res.rows
				this.queryParams.total = res.total
			})

			// let userInfo = JSON.parse(localStorage.getItem('userInfo'))
			// console.log(userInfo);
			// this.$http.post('/user/log',{
			// 	// userId:userInfo.userId
			// 	userId:1
			// }).then(res=>{
			// 	// console.log(res);
			// 	if(res.data){
			// 		this.list = res.data
			// 	}
			// })
		}
	}
};
</script>

<style lang="scss" scoped>
    .list{
        >div{
            margin-bottom: 10px;
            border-bottom: 1px solid rgba(0,0,0,.2);
            padding-bottom: 20px;
            margin-bottom: 20px;
            .user{
                padding-bottom: 10px;
                margin-bottom: 10px;
                border-bottom: 1px solid rgba(0,0,0,.05);
                display: flex;
                align-items: center;
                justify-content: space-between;
                >div{
                    display: flex;

                    img{
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                        border: 1px solid rgba(0,0,0,.2);
                        margin-right: 10px;
                    }
                }
                .delete{
                    border: 1px solid red;
                    padding: 5px 20px;
                    border-radius:5px;
                    color: red;
                }
            }
            .aircat{
                .tit{
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                .msg{
                    text-indent: 2em;
                    color : rgba(0,0,0,.7);
                    font-size: 15px;
                }
            }
        }
    }
</style>